<div
  class="cmdk overlay"
  [class.is-open]="open()"
  [@backdrop]="open() ? 'open' : 'closed'"
  (@backdrop.done)="onBackdropAnimationDone($event)"
  (click)="onBackdropClick($event)"
  role="presentation"
>
  <div
    class="panel-anim"
    [class.is-open]="open()"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'jobboard.platform.cmdk.aria.title' | transloco"
    [attr.aria-hidden]="open() ? null : 'true'"
    [attr.inert]="open() ? null : ''"
    (click)="$event.stopPropagation()"
  >
    <div class="panel ct-card">
      <cmdk-command class="command" [filter]="cmdkFilter">
        <div class="search">
          <fa-icon class="search-icon" [icon]="icons.search" aria-hidden="true"></fa-icon>
          <input
            #searchInput
            cmdkInput
            class="input"
            [attr.placeholder]="'jobboard.platform.cmdk.search.placeholder' | transloco"
            [attr.aria-label]="'jobboard.platform.cmdk.search.aria' | transloco"
            [value]="query()"
            (input)="onQueryInput($event)"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
          />
        </div>

        <cmdk-list class="list" [attr.aria-label]="'Suggestions'">
          <div *cmdkEmpty class="empty">
            {{ 'jobboard.platform.cmdk.empty' | transloco }}
          </div>

          <div class="list-inner">
            <cmdk-group [label]="'jobboard.platform.cmdk.groups.jobs' | transloco" class="group">
              @for (item of filteredStaticJobs(); track item.key) {
                <button
                  cmdkItem
                  type="button"
                  class="item"
                  [value]="item.key | transloco"
                  (selected)="onStaticAction(item)"
                >
                  <span class="left">
                    <fa-icon [icon]="item.icon" aria-hidden="true" class="item-icon"></fa-icon>
                    <span class="label">{{ item.key | transloco }}</span>
                  </span>
                </button>
              }

              @for (item of jobResults(); track item.id) {
                <button
                  cmdkItem
                  type="button"
                  class="item"
                  [value]="item.title + ' ' + item.companyName"
                  (selected)="onOpenJob(item)"
                >
                  <span class="left">
                    <fa-icon [icon]="icons.job" aria-hidden="true" class="item-icon"></fa-icon>
                    <span class="label-stack">
                      <span class="label">{{ item.title }}</span>
                      <span class="sublabel">{{ item.companyName }}</span>
                    </span>
                  </span>
                </button>
              }

              @if (
                showEmptyCategoryHint() &&
                filteredStaticJobs().length === 0 &&
                jobResults().length === 0
              ) {
                <button cmdkItem type="button" class="item" disabled>
                  <span class="left">
                    <span class="label">{{
                      'jobboard.platform.cmdk.empty-category' | transloco
                    }}</span>
                  </span>
                </button>
              }
            </cmdk-group>

            <cmdk-group
              [label]="'jobboard.platform.cmdk.groups.applications' | transloco"
              class="group"
            >
              @for (item of filteredStaticApplications(); track item.key) {
                <button
                  cmdkItem
                  type="button"
                  class="item"
                  [value]="item.key | transloco"
                  (selected)="onStaticAction(item)"
                >
                  <span class="left">
                    <fa-icon [icon]="item.icon" aria-hidden="true" class="item-icon"></fa-icon>
                    <span class="label">{{ item.key | transloco }}</span>
                  </span>
                </button>
              }

              @for (item of applicationResults(); track item.kind + '-' + item.id) {
                <button
                  cmdkItem
                  type="button"
                  class="item"
                  [value]="item.title + ' ' + item.companyName"
                  (selected)="onOpenApplication(item)"
                >
                  <span class="left">
                    <fa-icon
                      [icon]="item.kind === 'invitation' ? icons.invitation : icons.application"
                      aria-hidden="true"
                      class="item-icon"
                    ></fa-icon>
                    <span class="label-stack">
                      <span class="label">
                        {{ item.title }}
                        @if (item.companyName) {
                          <span class="inline-sub">• {{ item.companyName }}</span>
                        }
                      </span>
                      @if (item.kind === 'invitation') {
                        <span class="sublabel">{{
                          'jobboard.platform.cmdk.labels.invitation' | transloco
                        }}</span>
                      }
                    </span>
                  </span>
                </button>
              }

              @if (
                showEmptyCategoryHint() &&
                filteredStaticApplications().length === 0 &&
                applicationResults().length === 0
              ) {
                <button cmdkItem type="button" class="item" disabled>
                  <span class="left">
                    <span class="label">{{
                      'jobboard.platform.cmdk.empty-category' | transloco
                    }}</span>
                  </span>
                </button>
              }
            </cmdk-group>

            <cmdk-group
              [label]="'jobboard.platform.cmdk.groups.functions' | transloco"
              class="group"
            >
              @for (item of filteredStaticFunctions(); track item.key) {
                <button
                  cmdkItem
                  type="button"
                  class="item"
                  [value]="item.key | transloco"
                  (selected)="onStaticAction(item)"
                >
                  <span class="left">
                    <fa-icon [icon]="item.icon" aria-hidden="true" class="item-icon"></fa-icon>
                    <span class="label">{{ item.key | transloco }}</span>
                  </span>
                </button>
              }

              @if (showEmptyCategoryHint() && filteredStaticFunctions().length === 0) {
                <button cmdkItem type="button" class="item" disabled>
                  <span class="left">
                    <span class="label">{{
                      'jobboard.platform.cmdk.empty-category' | transloco
                    }}</span>
                  </span>
                </button>
              }
            </cmdk-group>
          </div>
        </cmdk-list>

        <div class="footer">
          <div class="footer-left"></div>
          <div class="footer-right">
            <app-platform-kbd keys="Esc"></app-platform-kbd>
            <span class="footer-text">{{ 'jobboard.platform.cmdk.footer.close' | transloco }}</span>
          </div>
        </div>
      </cmdk-command>
    </div>
  </div>
</div>
